import useId from '../utils/useId';
import * as React from 'react';
export const crossriverSvg = React.forwardRef(function crossriverSvgInner(
  props,
  ref,
) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  const id_2 = baseId + '_2';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F1F5F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.76 21.778c-.069-2.773 4.03-2.85 8.125-2.643.482-.475.847-.971 1.252-1.454-2-.592-8.506-2.91-10.69.034-1.517 2.044 1.314 4.063 1.314 4.063Z',
      fill: `url(#bi_crossriver__a_${id_0})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M26.317 16.905c-1.339 1.308-2.688 2.534-6.119 2.731a20.577 20.577 0 0 1-3.795-.136s-5.03 4.935-9.728 3.882c0 0-2.255-.462-3.164-2.04.625.659 1.223 1.332 3.274 1.448 1.472.081 3.111-.656 4.599-1.794a18.367 18.367 0 0 0 3.215-3.237c.027-.035 1.808-2.368 1.899-2.498 3.306-4.458 7.413-8.21 10.912-7.047 2.288.758 2.26 5.416-1.093 8.691Zm-.546-4.555c-.57.012-1.847.18-4.166 2.122-1.553 1.295-3.245 2.983-4.257 4.022 3.108.747 5.858.29 7.494-1.003 2.552-2.083 2.445-5.18.929-5.141Z',
      fill: `url(#bi_crossriver__b_${id_1})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.674 23.396c4.701 1.052 9.73-3.883 9.73-3.883l.945-1.007c1.012-1.05 2.704-2.739 4.255-4.034 2.32-1.942 3.598-2.11 4.166-2.122l1.64-4.136c-3.498-1.164-7.607 2.59-10.913 7.047-.09.13-1.872 2.463-1.897 2.498a18.43 18.43 0 0 1-3.217 3.237c-1.487 1.138-3.127 1.875-4.599 1.794',
      fill: `url(#bi_crossriver__c_${id_2})`,
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_crossriver__a_${id_0}`,
          x1: 16.226,
          y1: 19.015,
          x2: 1.619,
          y2: 19.015,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#00CBFF',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.21,
          stopColor: '#00C7FD',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.4,
          stopColor: '#00BDF8',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.58,
          stopColor: '#01AAF0',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.76,
          stopColor: '#0191E4',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.93,
          stopColor: '#0270D5',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#0260CD',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_crossriver__b_${id_1}`,
          x1: 33.779,
          y1: 15.773,
          x2: 0.358,
          y2: 15.773,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#00CBFF',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.21,
          stopColor: '#00C7FD',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.4,
          stopColor: '#00BDF8',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.58,
          stopColor: '#01AAF0',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.76,
          stopColor: '#0191E4',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.93,
          stopColor: '#0270D5',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#0260CD',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_crossriver__c_${id_2}`,
          x1: 26.214,
          y1: 7.27,
          x2: 8.169,
          y2: 25.981,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#00CBFF',
          stopOpacity: 0,
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.02,
          stopColor: '#00C6FD',
          stopOpacity: 0.04,
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.23,
          stopColor: '#01A2EC',
          stopOpacity: 0.38,
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.41,
          stopColor: '#0186DF',
          stopOpacity: 0.65,
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.57,
          stopColor: '#0271D5',
          stopOpacity: 0.84,
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.7,
          stopColor: '#0265CF',
          stopOpacity: 0.96,
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.77,
          stopColor: '#0260CD',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.8,
          stopColor: '#0260CD',
          stopOpacity: 0.91,
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.86,
          stopColor: '#0260CD',
          stopOpacity: 0.69,
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.93,
          stopColor: '#0260CD',
          stopOpacity: 0.34,
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#0260CD',
          stopOpacity: 0,
        }),
      ),
    ),
  );
});
crossriverSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var crossriver = {
  category: 'brand',
  colorable: false,
  name: 'crossriver',
  svg: crossriverSvg,
};
